import { Col } from "react-bootstrap";
import ObjectivePerson from "./ObjectivePerson";
import "./ObjectivePeopleList.css";

function ObjectivePeopleList({ people, language }) {
  return (
    <Col className="objective-people-list">
      {people.map((element) => (
        <ObjectivePerson
          key={element._id}
          id={element._id}
          firstName={element.firstName}
          lastName={element.lastName}
          profileName={element.profileName}
          profileNameEnglish={element.profileNameEnglish}
          language={language}
        />
      ))}
    </Col>
  );
}

export default ObjectivePeopleList;
